import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { CouponModalStyle } from "./CouponModal.styled";
import Button from "react-bootstrap/Button";
import { convertTime2 } from "../../common/ConvertTime";
import "../Modals/modalstyles.css";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getCouponCodesList } from "../../api/CouponApi";
import { useDB } from "../../context/DynamoDBContext";
import { getMonthString } from "../../common/ConvertMonth";
import { getSubscriptionString } from "../../common/ConvertSubscription";
import { ModalTitle } from "../../styles/ModalStyles";

const ViewCoupons = ({ visible, setVisible, promoGroup }) => {
  const { dynamoDBClient } = useDB();
  const tableRef = useRef();
  const [enableApi, setEnableApi] = useState(false);
  const [list, setList] = useState([]);
  const [nextPage, setNextPage] = useState({ Code: "" });
  const [checkScroll, setCheckScroll] = useState(false);
  const queryClient = useQueryClient();
  const [tableLoading, setTableLoading] = useState(true);
  const [tempList, setTempList] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [enableSearch, setEnableSearch] = useState(false);
  const [sortValue, setSortValue] = useState(null);

  const handleScroll = () => {
    if (!checkScroll) {
      const table = tableRef.current;
      const scrollPosition = table.scrollTop;
      const totalHeight = table.scrollHeight - table.clientHeight;

      if (scrollPosition >= totalHeight * 0.5) {
        setCheckScroll(true);
        if (nextPage) {
          queryClient.fetchQuery(["viewPromoCodes", promoGroup.PromoGroupId]);
        } else {
          setCheckScroll(false);
        }
      }
    }
  };

  const {
    status: couponStatus,
    data: couponData,
    isFetching: couponFetch,
  } = useQuery({
    queryKey: ["viewPromoCodes", promoGroup.PromoGroupId],
    queryFn: () =>
      getCouponCodesList(dynamoDBClient, promoGroup.PromoGroupId, nextPage),
    enabled: enableApi,
    staleTime: 0,
    cacheTime: 0,
    onSuccess: (data) => {
      const arr = data.Items;

      const nextPagetoLoad = data?.LastEvaluatedKey;

      if (arr.length > 0) {
        const check = nextPagetoLoad?.Code === nextPage?.Code;
        if (!check || !nextPagetoLoad?.Code) {
          const result = [...list, ...arr];
          setList(result);
          setTempList(result);
          if (result.length < 10 && result.length < promoGroup.NumberOfPromos) {
            queryClient.invalidateQueries({
              queryKey: ["viewPromoCodes", promoGroup.PromoGroupId],
            });
            queryClient.fetchQuery(["viewPromoCodes", promoGroup.PromoGroupId]);
          } else {
            setEnableApi(false);
            setTableLoading(false);
          }
        } else {
          queryClient.fetchQuery(["viewPromoCodes", promoGroup.PromoGroupId]);
        }
      } else {
        queryClient.fetchQuery(["viewPromoCodes", promoGroup.PromoGroupId]);
      }

      if (nextPagetoLoad) {
        setNextPage(nextPagetoLoad);
        setCheckScroll(false);
      } else {
        setNextPage(null);
        setCheckScroll(true);
      }
    },
  });

  const searchToPerform = (query) => {
    const searchTerm = query.toLowerCase(); // Convert query to lowercase for case-insensitive search

    // Use filter to find matching objects
    const results = tempList.filter((item) => {
      const emailMatch = item?.Email?.toLowerCase().includes(searchTerm);
      const codeMatch = item.Code.toLowerCase().includes(searchTerm);

      // Return true if either Email or code matches the search term
      return emailMatch || codeMatch;
    });

    setList(results);
  };

  const handleKeyPress = (e) => {
    if (e.key == "Enter") {
      setEnableSearch(true);
      searchToPerform(searchData);
    }
  };

  const sortData = (sort) => {
    setSortValue(sort);
    const result = list.sort((a, b) => {
      if (a?.PromoStatus === sort && b?.PromoStatus !== sort) {
        return -1;
      } else if (a?.PromoStatus !== sort && b?.PromoStatus === sort) {
        return 1;
      } else {
        return 0;
      }
    });

    setList(result);
  };

  useEffect(() => {
    if (visible) {
      setEnableApi(true);
    } else {
      setList([]);
      setNextPage(null);
      setCheckScroll(false);
      setTableLoading(true);
      setTempList([]);
      setSearchData("");
      setEnableSearch(false);
      setEnableApi(false);
      setSortValue("");
    }
  }, [visible]);

  return (
    <Modal show={visible} onHide={setVisible} size={"lg"}>
      <Modal.Header closeButton>
        <Modal.Title>
          <ModalTitle>View Promo Codes</ModalTitle>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CouponModalStyle>
          <div className="details-div">
            <p className="detail-heading">Promo Group Name :&ensp;</p>
            <p>{promoGroup.PromoGroupName}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Subscription Id :&ensp;</p>
            <p>{getSubscriptionString(promoGroup?.SubscriptionId)}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Date Created :&ensp;</p>
            <p>{convertTime2(promoGroup.DateCreated)}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Duration :&ensp; </p>
            <p>{getMonthString(promoGroup.Duration)}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Total Codes :&ensp; </p>
            <p>{promoGroup.NumberOfPromos}</p>
          </div>
          <div className="filter-div">
            <div className="search-bar">
              <input
                className="search-input"
                type="text"
                placeholder="Search"
                value={searchData}
                onChange={(e) => {
                  setSearchData(e.target.value);
                  setEnableSearch(false);
                }}
                onKeyUp={handleKeyPress}
              />
              {enableSearch ? (
                <i
                  className="bi bi-x search-icon"
                  onClick={() => {
                    setSearchData("");
                    setEnableSearch(false);
                    setList(tempList);
                  }}
                ></i>
              ) : (
                <i
                  className="bi bi-search search-icon"
                  onClick={() => {
                    setEnableSearch(true);
                    searchToPerform(searchData);
                  }}
                ></i>
              )}
            </div>
            {/* <div className="dropdown-center">
                                        <button className="btn btn-secondary dropdown-toggle dropDown-custom" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                            {sortValue? sortValue: "Sort"}
                                        </button>
                                        <ul className="dropdown-menu menu2">
                                            <li onClick={()=>sortData("InActive")} ><a className="dropdown-item" >InActive</a></li>
                                            <li onClick={()=>sortData("REDEEMED")}><a className="dropdown-item" >REDEEMED</a></li>
                                            <li onClick={()=>sortData("EXPIRED")}><a className="dropdown-item" >EXPIRED</a></li>
                                            
                                        </ul>
                    </div> */}
          </div>

          <div className="table-container">
            <div className="table-div" ref={tableRef} onScroll={handleScroll}>
              <table className="table table-hover">
                <thead className="table-head">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Promotion Code</th>
                    <th scope="col">Email</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {tableLoading ? (
                    <tr>
                      <td colSpan={6}>
                        <p className="table-loading">Loading...</p>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length === 0 ? (
                        <tr>
                          <td colSpan={6}>
                            <p className="table-loading">No Data Available</p>
                          </td>
                        </tr>
                      ) : (
                        list.map((item, index) => (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td className="dropdown-item2">{item.Code}</td>
                            <td className="dropdown-item2">{item?.Email}</td>
                            <td className="dropdown-item2">
                              {convertTime2(item?.StartDate)}
                            </td>
                            <td className="dropdown-item2">
                              {convertTime2(item?.ExpirationTime)}
                            </td>
                            <td className="dropdown-item2">
                              {item?.PromoStatus
                                ? item.PromoStatus
                                : "InActive"}
                            </td>
                          </tr>
                        ))
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <p className="table-loading">
            {couponFetch ? (tableLoading ? "" : "Loading...") : ""}
          </p>
        </CouponModalStyle>
      </Modal.Body>

      <Modal.Footer>
        <CouponModalStyle>
          <Button variant="secondary" onClick={setVisible}>
            <p className="bootstrap-btn">Close</p>
          </Button>
        </CouponModalStyle>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewCoupons;
